<template>
  <transition @appear="enter" @enter="enter" @leave="leave" :css="false">
    <div class="TlDeskPin" :class="modifiers" :style="style">
      <div class="TlDeskPin-info" @mouseover="handleClick">
        <div class="TlDeskPin-img">
          <img v-if="images[pin.year]" :src="images[pin.year]" />
        </div>
        <div class="TlDeskPin-title">
          {{ pin.year }}
        </div>
        <div
          class="TlDeskPin-description"
          ref="description"
          :style="descriptionStyle"
        >
          {{ pin.description }}
        </div>
        <div class="TlDeskPin-divider" />
      </div>
    </div>
  </transition>
</template>

<script>
import { TweenMax } from "gsap";
import * as images from "@/data/historyImages";

export default {
  props: {
    range: Object,
    pin: Object,
    active: Boolean,
    index: Number,
  },
  data: () => ({
    images: images.pins,
    descriptionHeight: undefined,
  }),
  computed: {
    modifiers() {
      const cssClasses = [];
      if (this.active) cssClasses.push("TlDeskPin--active");
      return cssClasses.join(" ");
    },
    style() {
      const { year } = this.pin;
      const [yearA, yearB] = this.range.yearRangeForPos;
      const left = ((year - yearA) / (yearB - yearA)) * 100;
      return {
        left: `${left}%`,
      };
    },
    descriptionStyle() {
      const { active, descriptionHeight } = this;
      const height = active ? descriptionHeight : 0;
      return { height: `${height}px` };
    },
  },
  mounted() {
    this.updateDescriptionHeight();
  },
  methods: {
    updateDescriptionHeight() {
      const { $el } = this;
      const { description } = this.$refs;
      const elDisplay = $el.style.display;
      TweenMax.set($el, { display: "block" });
      TweenMax.set(description, { height: "auto" });
      this.descriptionHeight = description.offsetHeight;

      TweenMax.set(description, { clearProps: "height" });
      TweenMax.set($el, { display: elDisplay });
    },
    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          y: 30,
          onComplete: done,
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: 0.5 + this.index * 0.1,
          ease: "power2.easeInOut",
        },
      );
    },
    leave(el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 0,
        onComplete: done,
        ease: "power2.easeInOut",
      });
    },
    handleClick() {
      if (!this.active) this.$emit("pin-click");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './TlDeskPin.styl';
</style>
